<!--
 * @Author: ext.chenghuan8
 * @Date: 2025-11-28 10:51:17
 * @LastEditors: ext.chenghuan8
 * @LastEditTime: 2025-12-02 11:10:50
 * @Description:
 * @contact_information: ext.chenghuan8@jd.com
-->
<template>
  <div class="layout-root">
    <Header />
    <section class="layout-main">
      <router-view ref="children" />
    </section>
    <AiAssistantFloat />
  </div>
</template>

<script>
import Header from '../components/layouts/Header.vue'
import AiAssistantFloat from '../components/ai-assistant-float'

export default {
  name: 'home',
  components: { Header, AiAssistantFloat },
  data () {
    return {

    }
  },
  computed: {},
  created () {},
  methods: {}
}
</script>

<style scoped lang="less">
/* 与 Header 占位 .height（@maxHeight: 66px）一致，主区域占满视口余下高度 */
.layout-root {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.layout-main {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-height: 0;
  background: #f9fafb;
}
</style>
